import { Controller } from '@hotwired/stimulus'

// Modal controller for opening/closing modal dialogs
// Usage:
//   <button data-controller="modal" data-action="click->modal#open" data-modal-target-value="myModal">Open</button>
//   <div id="myModal" class="modal-overlay" data-controller="modal">
//     <div class="modal-backdrop" data-action="click->modal#close"></div>
//     <div class="modal">
//       <div class="modal-header">...</div>
//       <div class="modal-body">...</div>
//     </div>
//   </div>

export default class extends Controller {
  static values = {
    target: String // ID of the modal to open (used by trigger buttons)
  }

  connect() {
    this.boundKeydown = this.handleKeydown.bind(this)
  }

  disconnect() {
    document.removeEventListener('keydown', this.boundKeydown)
    document.body.classList.remove('overflow-hidden')
  }

  open(event) {
    if (event) event.preventDefault()

    // Find the modal by ID (from data-modal-target-value)
    const modalId = this.targetValue
    const overlay = document.getElementById(modalId)

    if (overlay) {
      overlay.classList.add('is-open')
      // Also add is-open to backdrop and modal inside
      const backdrop = overlay.querySelector('.modal-backdrop')
      const modal = overlay.querySelector('.modal')
      if (backdrop) backdrop.classList.add('is-open')
      if (modal) modal.classList.add('is-open')

      document.body.classList.add('overflow-hidden')

      // Add escape key listener
      document.addEventListener('keydown', this.boundKeydown)

      // Focus first focusable element
      setTimeout(() => {
        const focusable = overlay.querySelector('input:not([type="hidden"]), textarea, select, button:not([data-action*="close"])')
        if (focusable) focusable.focus()
      }, 100)
    }
  }

  close(event) {
    if (event) event.preventDefault()

    // Find the modal overlay - either this element or parent
    const overlay = this.element.closest('.modal-overlay') || this.element

    if (overlay) {
      overlay.classList.remove('is-open')
      const backdrop = overlay.querySelector('.modal-backdrop')
      const modal = overlay.querySelector('.modal')
      if (backdrop) backdrop.classList.remove('is-open')
      if (modal) modal.classList.remove('is-open')

      document.body.classList.remove('overflow-hidden')
      document.removeEventListener('keydown', this.boundKeydown)
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      // Find visible modal overlay and close it
      const visibleOverlay = document.querySelector('.modal-overlay.is-open')
      if (visibleOverlay) {
        visibleOverlay.classList.remove('is-open')
        const backdrop = visibleOverlay.querySelector('.modal-backdrop')
        const modal = visibleOverlay.querySelector('.modal')
        if (backdrop) backdrop.classList.remove('is-open')
        if (modal) modal.classList.remove('is-open')
        document.body.classList.remove('overflow-hidden')
        document.removeEventListener('keydown', this.boundKeydown)
      }
    }
  }
}
